module.exports = __webpack_public_path__ + "static/media/title1.614a757e.jpg";